<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <form>
    <string-form-field
      :label="$t('provider.fields.companyName')"
      required
      :value="value.companyName"
      :disabled="disabled"
      :error="findError('companyName')"
      @input="propertyChange('companyName', $event)"
    />

    <string-form-field
      :label="$t('provider.fields.fiscalCode')"
      required
      :value="value.fiscalCode"
      :disabled="disabled"
      :error="findError('fiscalCode')"
      @input="propertyChange('fiscalCode', $event)"
    />

    <string-form-field
      :label="$t('provider.fields.vatNumber')"
      required
      :value="value.vatNumber"
      :disabled="disabled"
      :error="findError('vatNumber')"
      @input="propertyChange('vatNumber', $event)"
    />
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import ErrorCounterMixin from "vue-forms/mixins/ErrorCounterMixin";

export default {
  mixins: [EditorMixin, ErrorCounterMixin]
};
</script>
